import { render, staticRenderFns } from "./GameListView.vue?vue&type=template&id=7a10ca3b&"
import script from "./GameListView.vue?vue&type=script&lang=js&"
export * from "./GameListView.vue?vue&type=script&lang=js&"
import style0 from "./GameListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a10ca3b')) {
      api.createRecord('7a10ca3b', component.options)
    } else {
      api.reload('7a10ca3b', component.options)
    }
    module.hot.accept("./GameListView.vue?vue&type=template&id=7a10ca3b&", function () {
      api.rerender('7a10ca3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/GameListView.vue"
export default component.exports